<template>
    <dialogBox @close="this.$emit('close')">
            <template v-slot:title>{{$t('ReopenTicket')}}</template>
            <template v-slot:body>
                <!-- <div class="mb-3">
                    <label class="form-label">{{ $t('Status') }}</label>
                    <select
                        class="form-select mb-3"
                        data-plugin="choices"
                        v-model="form.decidedStatus"
                        >
                        <option v-for="item in listStatus" :key="item" :value="item.value">{{ item.label }}</option>
                    </select>
                </div> -->
                <div class="mb-3">
                    <h5 class="form-label">{{ $t('Comment') }}</h5>
                    <span class="mb-3 text-muted fs-12">Обов'язково вкажіть додаткові дані у чат тікету, наприклад, версію додатку або те, що немає в описі тікету. </span>
                    <span class="mb-3 text-muted fs-12"><br/>Також, додайте відео/фото-фіксацію причини перевідкриття тікету.</span>
                    <textarea class="form-control mt-3" rows="3" v-model="form.comment" :placeholder="$t('Cause')"></textarea>
                </div>
            </template>
            <template v-slot:footer-bottom>
                <button class="btn link-success fw-medium" @click="this.$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('cancel') }} </button>
                <button 
                    type="button" 
                    class="btn btn-primary" 
                    @click="toReopen()"
                >
                    {{ $t('Add') }}
                </button>
            </template>
        </dialogBox>
</template>

<script>
import dialogBox from '@/components/modal/dialog'
import { sendReopenTicketTelegram } from '@/usabilityScripts/logsTelegram.js'
import { Tickets } from '@/API'
import { nameWorker, tgAccWorker } from '@/usabilityScripts/getNameWorker'
import { storeS } from '@/store'
import { mutateTypeTicket, 
        mutateStatusTicket,
        mutateDecidedStatusTicket,
        mutatePriorityTicket,
        mutateProblemEnv,
        nameTag
      } from '@/usabilityScripts/globalMutate.js'

let apiServe = new Tickets();

export default {
    props: ['id', 'objCard'],
    components: {
        dialogBox
    },
    data(){
        return {
            form: {
                comment: "",
                whoReopen: storeS.userbase.userid, // хто перевідкрив тікет (формат як whoPassedTest)
            },
        }
    },
    methods: {
        toReopen(){
            apiServe.reopenTicket(this.id, this.form).then(result => {
                if(result.status == 'done'){
                    this.$toast.success(`done`);
                    this.sendTg()
                    this.eventBus.emit('UpdateCard', true)
                    this.$emit('close')
                } else if(result.status == 'error'){
                    this.$toast.error(result.error[0]);
                }
            })
        },
        sendTg(){
            // Надсилаємо оповіщення в тг

            var ticketdId = this.objCard.ticketId;
            var createWorkerId = this.nameWorker(this.user.userid);
            var tgAccCreateWorker = this.tgWorker(this.user.userid).tgNick;
            var ticketName = this.objCard.ticketName;
            var createComment = this.form.comment
            var project = this.mutateProblemEnv(this.objCard.problemEnvironment)
            var inJobWorkerName = this.nameWorker(this.objCard.inJobWorkers ? this.objCard.inJobWorkers[0].workerName : "Ніхто не працює над тікетом");
            var inJobWorkerTgName = this.tgWorker(this.objCard.inJobWorkers ? this.objCard.inJobWorkers[0].workerId : "Ніхто не працює над тікетом").tgNick;

            // Викликаємо функцію для відправки повідомлення в телеграм
            sendReopenTicketTelegram(ticketName, ticketdId, createWorkerId, tgAccCreateWorker, createComment, project, inJobWorkerName, inJobWorkerTgName)
            .then(response => {
                console.log('Telegram API response:', response.data)
                // this.$toast.success(this.$t('msgSent'))
                this.$emit('close')
            })
            .catch(error => console.error('Telegram API error:', error)); 
        },
        nameWorker(item){
            // мутейт імені співробітника
            return nameWorker(item)
        },
        tgWorker(item) {
            // отримання нікнейму співробітника
            return tgAccWorker(item);
        },
        mutateProblemEnv(e){
      
            // return this.developmentProjects.find(el => el.projectKey === e).projectName
            const project = this.developmentProjects.find(el => el.projectKey === e);

            if (!project) {
                console.warn(`Проєкт з ключем ${e} не знайдено`);
                
                return "Проєкт з ключем " + e + " не знайдено"; // або поверніть значення за замовчуванням
            }

            return project.projectName;
        },
    },
    computed:{
        developmentProjects() {
            // Отримання проектів
            return storeS.developmentProjects
        },
        user(){
            return storeS.userbase
        }
    }
}
</script>